import { TitleButton } from '@/common/buttons/TitleButton';
import { ActionDialog } from '@/common/dialog/ActionDialog';
import { useDialog } from '@/common/dialog/DialogContext';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { AbvMcdPymtActualsSplitList } from './AbvMcdPymtActualsSplitList';

export const AbvMcdPymtActualsSplitGrpDetail = () => {
  const { entityObj } = useEntityMgr();

  const { openDialog } = useDialog();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    {
      id: 'mcdPymtActualsSplitTab',
      label: 'Splits',
      content: <AbvMcdPymtActualsSplitList mcdPymtActualsSplitGrpId={entityObj?.id} />,
    },
  ];

  const onCalcRates = () => {
    openDialog(ActionDialog, {
      data: {
        title: 'Calculate Rates',
        pluginCode: 'MCD_PYMT_ACTUALS_SPLIT_ACTION_PLUGIN',
        entity: 'MCD_PYMT_ACTUALS_SPLIT_GRP',
        addlReqData: {
          entityId: entityObj?.id,
          startPeriodId: entityObj?.startPeriodId,
          endPeriodId: entityObj?.endPeriodId,
        },
      },
    });
  };

  const augButtons = (buttons) => {
    buttons.push(<TitleButton toolTip={'Calculate Rates'} icon={fas.faEdit} onClick={onCalcRates}></TitleButton>);
  };

  return <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />;
};
